module.exports = __webpack_public_path__ + "media/images/clients/info-9888cea5770cf60ea031005e1c3e1c6f.svg";